var React = require('react');

function ScanInStore (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.91758 2.39999H4.65091C3.4727 2.39999 2.51758 3.35512 2.51758 4.53333V8.79999M8.91758 21.6H4.65091C3.4727 21.6 2.51758 20.6449 2.51758 19.4667V15.2M15.3176 2.39999H19.5842C20.7624 2.39999 21.7176 3.35512 21.7176 4.53333V8.79999M21.7176 15.2V19.4667C21.7176 20.6449 20.7624 21.6 19.5842 21.6H15.3176M2.51758 12.0003H21.7176","stroke":"white","strokeWidth":"2","strokeLinecap":"round"}));
}

ScanInStore.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = ScanInStore;

ScanInStore.default = ScanInStore;
